/* eslint-disable react/display-name */
'use client';

import React from 'react';

import { isEmpty } from 'lodash';
import cx from 'classnames';

import styles from './textarea.module.scss';

interface TextareaProps {
  value?: string | number;
  onChange?: (value: string) => void | React.Dispatch<React.SetStateAction<string>>;
  placeHolder?: string;
  disabled?: boolean;
  error?: string;
  onEnterClick?: () => void;
  onBlur?: () => void;
  onFocus?: () => void;
  className?: string;
  width?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>((props, ref) => {
  const {
    value,
    onChange,
    placeHolder,
    disabled,
    error,
    onEnterClick,
    onBlur,
    onFocus,
    className,
    width,
  } = props;

  const handleChange = (e: { target: { value: React.SetStateAction<string> } }) => {
    if (onChange) onChange(e.target.value.toString());
  };

  const handleOnBlur = () => {
    if (onBlur) onBlur();
  };

  const handleOnFocus = () => {
    if (onFocus) onFocus();
  };

  const handleEnterPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (onEnterClick) {
      if (e.key === 'Enter') {
        onEnterClick();
      }
    }
  };

  const hasError = !isEmpty(error);

  return (
    <textarea
      ref={ref}
      placeholder={placeHolder}
      className={cx(styles.textarea, className, {
        [styles.error]: hasError,
        [styles.disabled]: disabled,
      })}
      disabled={disabled}
      value={value}
      onChange={handleChange}
      onBlur={handleOnBlur}
      onFocus={handleOnFocus}
      onKeyDown={handleEnterPress}
      style={{ width: width }}
    />
  );
});

export default Textarea;
